"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateZipCode = exports.validatePaymentInfo = exports.validateInputFieldValue = exports.validateCustomFields = exports.validateCardNumber = exports.validateCardExpiry = exports.validateCardCVV = exports.validateBillingNameField = exports.isCustomFieldValid = exports._validateZipCode = exports._validateInputFieldValue = exports._validateCardNumber = exports._validateCardExpiry = exports._validateCardCVV = void 0;
var _validations = require("../validations");
var _constants = require("../../constants/constants");
var _nativePaymentPropsGenerator = require("./nativePaymentPropsGenerator");
var _commonUtils = require("../commonUtils");
var _fieldsMessages = require("../../components/fields/fieldsMessages");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var isCustomFieldValid = function isCustomFieldValid(referenceContainer) {
  validateCustomFields(referenceContainer);
  return !(0, _commonUtils.classExists)(['payment-widget__checkout__fields__input__error']);
};
exports.isCustomFieldValid = isCustomFieldValid;
var validateCustomFields = function validateCustomFields(referenceContainer) {
  (0, _commonUtils.focusOnCustomFields)([referenceContainer['emailInputField'], referenceContainer['phoneInputField'], referenceContainer['nameInputField']]);
};
exports.validateCustomFields = validateCustomFields;
var validatePaymentInfo = function validatePaymentInfo(paymentInfo, formatMessage, cardTypes, isFromAdyen) {
  if (!paymentInfo.isStoredCard) {
    var _paymentInfo$addressL, _paymentInfo$addressL2, _paymentInfo$cardCVV, _paymentInfo$cardCVV2, _paymentInfo$cardExpi, _paymentInfo$cardExpi2, _paymentInfo$cardNumb, _paymentInfo$cardNumb2, _paymentInfo$firstNam, _paymentInfo$firstNam2, _paymentInfo$lastName, _paymentInfo$lastName2, _paymentInfo$fullName, _paymentInfo$fullName2, _paymentInfo$city, _paymentInfo$city2, _paymentInfo$country, _paymentInfo$country2, _paymentInfo$state, _paymentInfo$country3, _paymentInfo$state2, _paymentInfo$zipCode, _paymentInfo$country4, _paymentInfo$zipCode2;
    var addressLine = {
        value: paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$addressL = paymentInfo.addressLine) === null || _paymentInfo$addressL === void 0 ? void 0 : _paymentInfo$addressL.value,
        error: (0, _validations.validateIsEmpty)((0, _nativePaymentPropsGenerator.getAddressLineErrorMessages)(formatMessage), paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$addressL2 = paymentInfo.addressLine) === null || _paymentInfo$addressL2 === void 0 ? void 0 : _paymentInfo$addressL2.value)
      },
      cardCVV = {
        value: paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$cardCVV = paymentInfo.cardCVV) === null || _paymentInfo$cardCVV === void 0 ? void 0 : _paymentInfo$cardCVV.value,
        error: validateCardCVV((0, _nativePaymentPropsGenerator.getCardCVVErrorMessages)(formatMessage), paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$cardCVV2 = paymentInfo.cardCVV) === null || _paymentInfo$cardCVV2 === void 0 ? void 0 : _paymentInfo$cardCVV2.value)
      },
      cardExpiry = {
        value: paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$cardExpi = paymentInfo.cardExpiry) === null || _paymentInfo$cardExpi === void 0 ? void 0 : _paymentInfo$cardExpi.value,
        error: validateCardExpiry((0, _nativePaymentPropsGenerator.getCardExpiryErrorMessages)(formatMessage), paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$cardExpi2 = paymentInfo.cardExpiry) === null || _paymentInfo$cardExpi2 === void 0 ? void 0 : _paymentInfo$cardExpi2.value)
      },
      cardNumber = {
        value: paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$cardNumb = paymentInfo.cardNumber) === null || _paymentInfo$cardNumb === void 0 ? void 0 : _paymentInfo$cardNumb.value,
        error: validateCardNumber((0, _nativePaymentPropsGenerator.getCardNumberErrorMessages)(formatMessage), (_paymentInfo$cardNumb2 = paymentInfo.cardNumber) === null || _paymentInfo$cardNumb2 === void 0 ? void 0 : _paymentInfo$cardNumb2.value, {
          cardTypes: cardTypes
        })
      },
      firstName = {
        value: paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$firstNam = paymentInfo.firstName) === null || _paymentInfo$firstNam === void 0 ? void 0 : _paymentInfo$firstNam.value,
        error: (0, _validations.validateIsEmpty)((0, _nativePaymentPropsGenerator.getNameErrorMessages)(formatMessage), paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$firstNam2 = paymentInfo.firstName) === null || _paymentInfo$firstNam2 === void 0 ? void 0 : _paymentInfo$firstNam2.value)
      },
      lastName = {
        value: paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$lastName = paymentInfo.lastName) === null || _paymentInfo$lastName === void 0 ? void 0 : _paymentInfo$lastName.value,
        error: (0, _validations.validateIsEmpty)((0, _nativePaymentPropsGenerator.getNameErrorMessages)(formatMessage), paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$lastName2 = paymentInfo.lastName) === null || _paymentInfo$lastName2 === void 0 ? void 0 : _paymentInfo$lastName2.value)
      },
      fullName = {
        value: paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$fullName = paymentInfo.fullName) === null || _paymentInfo$fullName === void 0 ? void 0 : _paymentInfo$fullName.value,
        error: (0, _validations.validateIsEmpty)((0, _nativePaymentPropsGenerator.getNameErrorMessages)(formatMessage), paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$fullName2 = paymentInfo.fullName) === null || _paymentInfo$fullName2 === void 0 ? void 0 : _paymentInfo$fullName2.value)
      },
      city = {
        value: paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$city = paymentInfo.city) === null || _paymentInfo$city === void 0 ? void 0 : _paymentInfo$city.value,
        error: (0, _validations.validateIsEmpty)((0, _nativePaymentPropsGenerator.getCityErrorMessages)(formatMessage), paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$city2 = paymentInfo.city) === null || _paymentInfo$city2 === void 0 ? void 0 : _paymentInfo$city2.value)
      },
      country = {
        value: paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$country = paymentInfo.country) === null || _paymentInfo$country === void 0 ? void 0 : _paymentInfo$country.value,
        error: (0, _validations.validateIsEmpty)((0, _nativePaymentPropsGenerator.getCountryErrorMessages)(formatMessage), paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$country2 = paymentInfo.country) === null || _paymentInfo$country2 === void 0 ? void 0 : _paymentInfo$country2.value)
      },
      state = {
        value: paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$state = paymentInfo.state) === null || _paymentInfo$state === void 0 ? void 0 : _paymentInfo$state.value,
        error: (0, _validations.validateIsEmpty)((0, _nativePaymentPropsGenerator.getStateErrorMessages)(formatMessage, (0, _commonUtils.getRequiredPropsObj)(_fieldsMessages.getStatePropsObj, ((paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$country3 = paymentInfo.country) === null || _paymentInfo$country3 === void 0 ? void 0 : _paymentInfo$country3.value) || 'US').toLowerCase()).fieldError), paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$state2 = paymentInfo.state) === null || _paymentInfo$state2 === void 0 ? void 0 : _paymentInfo$state2.value)
      },
      zipCode = {
        value: paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$zipCode = paymentInfo.zipCode) === null || _paymentInfo$zipCode === void 0 ? void 0 : _paymentInfo$zipCode.value,
        error: (0, _validations.validateIsEmpty)((0, _nativePaymentPropsGenerator.getZipCodeErrorMessages)(formatMessage, (0, _commonUtils.getRequiredPropsObj)(_fieldsMessages.getZipCodePropsObj, ((paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$country4 = paymentInfo.country) === null || _paymentInfo$country4 === void 0 ? void 0 : _paymentInfo$country4.value) || 'US').toLowerCase())), paymentInfo === null || paymentInfo === void 0 || (_paymentInfo$zipCode2 = paymentInfo.zipCode) === null || _paymentInfo$zipCode2 === void 0 ? void 0 : _paymentInfo$zipCode2.value)
      };
    var isBillingAddressValid = addressLine.error === '' && city.error === '' && country.error === '' && state.error === '' && zipCode.error === '';
    var isValid = isBillingAddressValid && cardCVV.error === '' && cardExpiry.error === '' && cardNumber.error === '' && (firstName.error === '' && lastName.error === '' || fullName.error === '');
    var billingAddressDetails = {
      addressLine: addressLine,
      city: city,
      country: country,
      state: state,
      zipCode: zipCode
    };
    return isFromAdyen ? _objectSpread(_objectSpread({}, billingAddressDetails), {}, {
      isValid: isBillingAddressValid
    }) : _objectSpread(_objectSpread({
      firstName: firstName,
      lastName: lastName,
      fullName: fullName,
      cardCVV: cardCVV,
      cardExpiry: cardExpiry,
      cardNumber: cardNumber
    }, billingAddressDetails), {}, {
      isValid: isValid
    });
  } else {
    var storedCardCVV = {
      value: paymentInfo.storedCardCVV.value,
      error: validateCardCVV((0, _nativePaymentPropsGenerator.getCardCVVErrorMessages)(formatMessage), paymentInfo.storedCardCVV.value)
    };
    var _isValid = storedCardCVV.error === '';
    return {
      storedCardCVV: storedCardCVV,
      isValid: _isValid
    };
  }
};
exports.validatePaymentInfo = validatePaymentInfo;
var _validateCardNumber = function _validateCardNumber(props, value, errorMessages) {
  var cardTypes = props.cardTypes || [];
  var pattern = props.pattern || _constants.CARD_NUMBER_VALIDATION_REGEX;
  if (!pattern.test(value)) {
    return errorMessages.isInvalidMessage;
  }
  if (!cardTypes.includes((0, _commonUtils.getFullCardNumberType)(value))) {
    return errorMessages.cardTypeNotSupported;
  }
  if (!(0, _commonUtils.luhnValidator)(value)) {
    return errorMessages.isInvalidMessage;
  }
  return '';
};
exports._validateCardNumber = _validateCardNumber;
var _validateCardExpiry = function _validateCardExpiry(props, value) {
  var pattern = props.pattern || _constants.CARD_EXPIRY_VALIDATION_REGEX;
  if (!pattern.test(value)) {
    return props.isInvalidMessage;
  }
  var currentDate = new Date();
  var expiryDateValues = value.split('/');
  var expiryDate = new Date((0, _commonUtils.getFullYear)(expiryDateValues[1]), expiryDateValues[0], 0);
  if (expiryDate < currentDate) {
    return props.cardExpired;
  }
  return '';
};
exports._validateCardExpiry = _validateCardExpiry;
var _validateCardCVV = function _validateCardCVV(props, value) {
  var pattern = props.pattern || _constants.CARD_CVV_VALIDATION_REGEX;
  if (!pattern.test(value)) {
    return props.isInvalidMessage;
  }
  return '';
};
exports._validateCardCVV = _validateCardCVV;
var validateCardNumber = function validateCardNumber(errorMessages, value, props) {
  return (0, _validations.fieldIsEmpty)(errorMessages.isEmptyMessage)(value) || _validateCardNumber(props, value, errorMessages);
};
exports.validateCardNumber = validateCardNumber;
var validateCardExpiry = function validateCardExpiry(props, value) {
  return (0, _validations.fieldIsEmpty)(props.isEmptyMessage)(value) || _validateCardExpiry(props, value);
};
exports.validateCardExpiry = validateCardExpiry;
var validateCardCVV = function validateCardCVV(props, value) {
  return (0, _validations.fieldIsEmpty)(props.isEmptyMessage)(value) || _validateCardCVV(props, value);
};
exports.validateCardCVV = validateCardCVV;
var _validateZipCode = function _validateZipCode(errorMessages, value, props) {
  var country = props.country;
  var pattern = errorMessages.pattern || _constants.ZIP_CODE_VALIDATION_REGEX[country];
  if (_constants.ZIP_CODE_VALIDATION_REGEX[country] && !pattern.test(value)) {
    return errorMessages.isInvalidMessage;
  }
  return '';
};
exports._validateZipCode = _validateZipCode;
var validateZipCode = function validateZipCode(errorMessages, value, props) {
  return (0, _validations.fieldIsEmpty)(errorMessages.isEmptyMessage)(value) || _validateZipCode(errorMessages, value, props);
};
exports.validateZipCode = validateZipCode;
var validateBillingNameField = function validateBillingNameField(paymentMethodDetails) {
  if (paymentMethodDetails.widgetNameOrder == 'FN') {
    (0, _commonUtils.focusOnDOMElementWithId)('payment-widget__checkout__full-name_input');
  } else {
    (0, _commonUtils.focusOnDOMElementWithId)('payment-widget__checkout__first-name_input');
    (0, _commonUtils.focusOnDOMElementWithId)('payment-widget__checkout__last-name_input');
  }
};
exports.validateBillingNameField = validateBillingNameField;
var _validateInputFieldValue = function _validateInputFieldValue(errorMessages, value) {
  var pattern = _constants.BILLING_ADDRESS_VALIDATION_REGEX;
  if (!pattern.test(value)) {
    return errorMessages.isInvalidValue;
  }
  if (_constants.EMOJI_REGEX.test(value)) {
    return errorMessages.isInvalidValue;
  }
  return '';
};
exports._validateInputFieldValue = _validateInputFieldValue;
var validateInputFieldValue = function validateInputFieldValue(errorMessages, value, props) {
  return (0, _validations.validateIsEmpty)(errorMessages, value) || _validateInputFieldValue(errorMessages, value, props);
};
exports.validateInputFieldValue = validateInputFieldValue;